// extracted by css-extract-rspack-plugin
export default {"header":"sqN8WEX___header"};